import React, { useEffect } from 'react';
import Link from 'next/link';
import { NextPage } from 'next';
import { useDispatch, useSelector } from 'react-redux';

import logoImg from '../assets/images/kecobo-logo.png';
import { withDashboardRedirect } from '../HOC/with-redirect';
import SignUpForm from '../components/forms/auth/signup-corporate-form';

import { RootState } from '../redux';
import { signupCorporate, newOTP } from '../redux/auth/actions';
import { SignupCorporateInputs, SignupCorporateErrors } from '../redux/auth/interfaces';
import { sendAnalytics } from '../redux/analytics/actions';

const SignupCorporatePage: NextPage = () => {
  const dispatch = useDispatch();
  const { isFetching, isFetchingOTP, errors } = useSelector((state: RootState) => state.auth);

  const signupUser = (data: SignupCorporateInputs) => {
    dispatch(signupCorporate(data));
  };

  const getOTP = (phoneNumber: string) => {
    if (phoneNumber === '') return;
    dispatch(newOTP(phoneNumber, false, true));
  };

  useEffect(() => {
    dispatch(
      sendAnalytics({
        event: 'corporateSignupPage',
        category: 'Navigation',
        meta: {},
      }),
    );
  }, []);

  return (
    <div className="px-4 pt-8 bg-white max-width lg:px-8">
      <div className="w-40 px-2 mx-auto md:w-48 lg:mx-0">
        <img src={logoImg} alt="" />
      </div>

      <div className="max-w-2xl mx-auto mt-8 lg:flex md:max-w-4xl lg:max-w-full">
        <div className="max-w-lg mx-auto lg:flex-1 lg:mx-0 lg:pr-0">
          <p className="text-3xl font-bold leading-tight tracking-wide text-center text-header lg:text-left sm:text-5xl">
            Corporate Account
          </p>

          <p className="px-0 mt-6 text-sm font-normal text-justify lg:font-medium sm:px-0 sm:text-lg lg:pr-8">
            Please enter your basic information and set up a new password for secure login and a
            useful experience around the platform.
          </p>
        </div>

        <div className="mt-8 lg:mt-0 lg:flex-1 lg:ml-12">
          <p className="mb-4 text-lg font-bold text-gray-700">Add your Details</p>

          <SignUpForm
            signupUser={signupUser}
            isCreatingAccount={isFetching}
            errors={errors as SignupCorporateErrors}
            getOTP={getOTP}
            fetchingOTP={isFetchingOTP}
          />

          <p className="pl-6 mt-4">
            Already have an account?{' '}
            <Link href="/signin">
              <a className="font-medium text-secondary">Sign In</a>
            </Link>
          </p>
        </div>
      </div>

      <div className="flex w-full px-6 py-4 mt-4 border-t border-gray-400 lg:px-12">
        <p className="flex-1">
          For help contact,{' '}
          <span className="font-semibold ">
            <a href="tel: 0791399159" className="text-indigo-500">
              0791399159
            </a>
            ,{' '}
            <a href="tel: 0756460413" className="text-indigo-500">
              0756460413
            </a>
          </span>{' '}
          or send an email to{' '}
          <span className="font-semibold ">
            <a href="mailto: nrr@copyright.go.ke" className="text-indigo-500">
              nrr@copyright.go.ke
            </a>
          </span>
        </p>
        <p className="flex-0">
          Kenya Copyrights Board,{' '}
          <span className="font-semibold">&#169;{new Date().getFullYear()}</span>
        </p>
      </div>
    </div>
  );
};

export default withDashboardRedirect(SignupCorporatePage);
